/**
 * Ported from Fluid Functionalism's surface-classes (registry:lib).
 *
 * Lookup tables for the surface classes defined in the "Surfaces" section of
 * assets/css/theme.css. Upstream these are Tailwind utilities and the literal
 * strings are what Tailwind's scanner needs; here they are plain CSS classes,
 * and the tables stay so a level picked at runtime maps to a real class.
 *
 *   <div className={surfaceClasses(level)} />
 */

export const SURFACE_BG = {
  1: "bg-surface-1",
  2: "bg-surface-2",
  3: "bg-surface-3",
  4: "bg-surface-4",
  5: "bg-surface-5",
  6: "bg-surface-6",
  7: "bg-surface-7",
  8: "bg-surface-8",
};

export const SURFACE_SHADOW = {
  1: "shadow-surface-1",
  2: "shadow-surface-2",
  3: "shadow-surface-3",
  4: "shadow-surface-4",
  5: "shadow-surface-5",
  6: "shadow-surface-6",
  7: "shadow-surface-7",
  8: "shadow-surface-8",
};

export const SURFACE_HOVER_BG = {
  1: "hover:bg-surface-1",
  2: "hover:bg-surface-2",
  3: "hover:bg-surface-3",
  4: "hover:bg-surface-4",
  5: "hover:bg-surface-5",
  6: "hover:bg-surface-6",
  7: "hover:bg-surface-7",
  8: "hover:bg-surface-8",
};

export const SURFACE_HOVER_SHADOW = {
  1: "hover:shadow-surface-1",
  2: "hover:shadow-surface-2",
  3: "hover:shadow-surface-3",
  4: "hover:shadow-surface-4",
  5: "hover:shadow-surface-5",
  6: "hover:shadow-surface-6",
  7: "hover:shadow-surface-7",
  8: "hover:shadow-surface-8",
};

const clampLevel = (level) => Math.round(Math.max(1, Math.min(8, level)));

/** Background plus shadow classes for a level. */
export function surfaceClasses(bgLevel, shadowLevel = bgLevel) {
  // Round after clamping so a fractional level can't index out of the lookup
  // tables (which would render "undefined undefined").
  return `${SURFACE_BG[clampLevel(bgLevel)]} ${SURFACE_SHADOW[clampLevel(shadowLevel)]}`;
}

/** The hover half of `surfaceClasses`: the level a surface rises to while the
 *  pointer is on it. */
export function surfaceHoverClasses(bgLevel, shadowLevel = bgLevel) {
  return `${SURFACE_HOVER_BG[clampLevel(bgLevel)]} ${SURFACE_HOVER_SHADOW[clampLevel(shadowLevel)]}`;
}
